const XALT_INPUT_TYPES = {
    TEXT: 'text',
    PASSWORD: 'password',
    EMAIL: 'email',
    NUMBER: 'number',
};

export const input = {
    XALT_INPUT_TYPES,
};